/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import Popper from 'popper.js';
import { removeIdTokenLocalStorage } from '@catapultxos/sso-auth';
import OutsideClickHandler from 'react-outside-click-handler';
import bindMethods from 'auto-bind';

import { ReactComponent as Avatar } from '../../images/avatar_placeholder.svg';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const AvatarContainer = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 9999px;
  border: ${props => `2px solid ${props.theme.LABEL === 'catapult' ? props.theme.WARNING : props.theme.PRIMARY}`};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoggedInNameText = styled.p`
  color: ${props => props.theme.PRIMARY};
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
`;

const MenuIconContainer = styled.svg`
  fill: ${props => (props.theme.LABEL === 'catapult' ? props.theme.WARNING : props.theme.PRIMARY)};
  margin: 0px 20px;
  cursor: pointer;
`;

class NavigationBarRight extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.popper = null;
    this.menuIconRef = React.createRef();
    this.menuPanelRef = React.createRef();

    this.state = {
      displayPopper: false,
    };
  }

  componentDidMount() {
    this.popper = new Popper(this.menuIconRef.current, this.menuPanelRef.current, {
      placement: 'top-start',
    });
  }

  componentWillUnmount() {
    this.popper.destroy();
  }

  handleLogout() {
    removeIdTokenLocalStorage();
    window.location.replace(process.env.REACT_APP_SSO_UI_LOGOUT_URL);
  }

  handleOutsideClick() {
    const { displayPopper } = this.state;

    if (displayPopper) {
      this.setState({ displayPopper: false });
    }
  }

  render() {
    const { t } = this.props;
    const { displayPopper } = this.state;

    return (
      <Container>
        <LoggedInNameText id="NavigationBar.Text.LoggedInUser">
          {/* TODO: This will change when we know who is logged in */}
          IDM Admin
        </LoggedInNameText>

        <AvatarContainer>
          <Avatar id="NavigationBar.Avatar" alt={t('NavigationBar.Avatar.AltText')} />
        </AvatarContainer>

        <MenuIconContainer
          ref={this.menuIconRef}
          id="NavigationBar.MenuIcon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          onClick={() => this.setState({ displayPopper: true })}
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </MenuIconContainer>

        <OutsideClickHandler onOutsideClick={this.handleOutsideClick}>
          <div
            id="NavigationBar.MenuPanel"
            ref={this.menuPanelRef}
            style={{
              display: displayPopper ? 'block' : 'none',
              background: 'white',
              padding: '10px',
              boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
              marginRight: '75px',
            }}
          >
            <ul id="NavigationBar.PanelOptions" style={{ cursor: 'pointer' }}>
              <li id="NavigationBar.PanelOptions.Logout" onClick={this.handleLogout}>
                {t('Shared.General.Logout')}
              </li>
            </ul>
          </div>
        </OutsideClickHandler>
      </Container>
    );
  }
}

NavigationBarRight.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

export default withTranslation()(NavigationBarRight);
